// Custom hook for Signup page logic
import { Form } from 'antd';
import { z } from 'zod';
import { useNavigate } from 'react-router-dom';
import { useMessage } from '@context/MessageProvider';
import { signupSchema } from '@validators/outside.schema';
import { useRegisterMutation } from './useAuthMutations';

export const useSignup = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { showMessage } = useMessage();
    const registerMutation = useRegisterMutation();
    
    const onFinish = async (values) => {
        try {
            const parsedValues = signupSchema.parse(values);
            
            const result = await registerMutation.mutateAsync({
                name: parsedValues.name,
                email: parsedValues.email,
                password: parsedValues.password
            });
            
            if (result?.routeToLogin) {
                navigate('/sign-in');
            }
        } catch (error) {
            if (error instanceof z.ZodError) {
                const fieldErrors = {};
                error.errors.forEach((err) => {
                    fieldErrors[err.path[0]] = err.message;
                });
                form.setFields(
                    Object.keys(fieldErrors).map((field) => ({
                        name: field,
                        errors: [fieldErrors[field]]
                    }))
                );
            }
        }
    };

    return {
        form,
        loading: registerMutation.isPending,
        onFinish
    };
};

